import { Controller } from "@hotwired/stimulus";
import intlTelInput from "intl-tel-input/intlTelInputWithUtils";

export default class extends Controller {
  static targets = ["input", "error", "hidden"];

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      initialCountry: "cl",
      countryOrder: ["cl", "ar", "pe", "mx", "es"],
      separateDialCode: true,
    });

    // Actualizar el campo hidden con el número completo cuando cambie
    this.inputTarget.addEventListener("input", () => this.updateHiddenField());
    this.inputTarget.addEventListener("countrychange", () =>
      this.updateHiddenField()
    );
  }

  updateHiddenField() {
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = this.iti.getNumber();
    }
  }

  validate() {
    const input = this.inputTarget;

    if (!input.value.trim()) {
      // Campo vacío, no validar aún
      input.classList.remove("invalid");
      if (this.hasErrorTarget) this.errorTarget.textContent = "";
      return;
    }

    if (this.iti.isValidNumber()) {
      input.classList.remove("invalid");
      if (this.hasErrorTarget) this.errorTarget.textContent = "";
    } else {
      input.classList.add("invalid");
      if (this.hasErrorTarget)
        // this.errorTarget.textContent = "Número no válido para este país";
        console.log("Número no válido para este país");
    }
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy();
    }
  }
}
